import React from 'react';
import { Collapse } from 'react-bootstrap';
import CheckboxInput from 'shared/components/CheckboxInput';

const AdvancedSpecs = (props) => {
  const {
    name,
    onChangeParameter,
    parameters,
    children,
    groupName,
    disabled
  } = props;

  const checked = parameters && parameters.has_advanced_specs === '1';

  const onChange = (e) => onChangeParameter(name, e.target.checked ? '1' : '0');

  return (
    <div>
      <div className="panel panel-default mb-3">
        <div className="panel-heading">
          <div className="panel-title m-0">
            <label htmlFor={name} className="advanced-specs-link m-0">
              <CheckboxInput
                inputClassName="mr-2"
                inputId={name}
                name={name}
                groupName={groupName}
                checked={checked}
                onChange={onChange}
                disabled={disabled} />
              {Spree.translations.advanced_specs}
            </label>
          </div>
        </div>
      </div>

      <Collapse in={checked}>
        {children}
      </Collapse>
    </div>
  );
};


AdvancedSpecs.defaultProps = {
  name: 'has_advanced_specs',
  groupName: 'parameters',
};

export default AdvancedSpecs;